import { Component, OnInit } from '@angular/core';
import { environment } from './../../../../environments/environment';

@Component({
  	selector: 'app-toolcards-stick-brainstorming',
  	templateUrl: './toolcards-stick-brainstorming.component.html',
  	styleUrls: ['./toolcards-stick-brainstorming.component.scss']
})
export class ToolcardsStickBrainstormingComponent implements OnInit {
	public env;

  	constructor() { }

  	ngOnInit() {
  		this.env=environment;
  	}

}
